/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='sw1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw1'">Sw1</vs-button>
          <vs-button :color="sel==='sw2'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw2'">Sw2</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task1Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task1Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task1Done?'#28C76F':'#4a5568'}">1</span>
              <span class="font-semibold text-sm flex-1">Configure VLANs on both switches</span>
              <span class="text-xs font-medium" :class="task1Done?'text-success':'text-grey'">{{ task1Progress }}/16</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swk in ['sw1','sw2']" :key="'t1-'+swk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ swkLabel(swk) }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in task1Items" :key="'t1-'+swk+'-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(swk)[item.key])"></div>
                    <code class="text-base" :class="getComp(swk)[item.key]?'text-success':''">{{ item.label }}</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 2 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task2Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task2Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task2Done?'#28C76F':'#4a5568'}">2</span>
              <span class="font-semibold text-sm flex-1">Assign VLANs to access ports</span>
              <span class="text-xs font-medium" :class="task2Done?'text-success':'text-grey'">{{ task2Progress }}/18</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">Sw1</span>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task2Sw1Items" :key="'t2-sw1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw1Completion[item.key])"></div>
                  <code class="text-base" :class="sw1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">Sw2</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task2Sw2Items" :key="'t2-sw2-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw2Completion[item.key])"></div>
                  <code class="text-base" :class="sw2Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 3 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task3Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task3Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task3Done?'#28C76F':'#4a5568'}">3</span>
              <span class="font-semibold text-sm flex-1">LLDP on e0/0 (vendor-neutral discovery)</span>
              <span class="text-xs font-medium" :class="task3Done?'text-success':'text-grey'">{{ task3Progress }}/8</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swk in ['sw1','sw2']" :key="'t3-'+swk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ swkLabel(swk) }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in task3Items" :key="'t3-'+swk+'-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(swk)[item.key])"></div>
                    <code class="text-base" :class="getComp(swk)[item.key]?'text-success':''">{{ item.label }}</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(saveDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:saveDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="saveDone?'CheckCircleIcon':'CircleIcon'" :svgClasses="saveDone?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone?'text-success':'text-grey'">{{ [sw1Completion.saved,sw2Completion.saved].filter(Boolean).length }}/2</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swk in ['sw1','sw2']" :key="'s-'+swk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ swkLabel(swk) }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(swk).saved)"></div>
                    <code class="text-base" :class="getComp(swk).saved?'text-success':''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='sw1'" key="sw1" id="sw1_terminal" :commands="sw1Commands" :prompt="sw1Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="Sw1" />
          <vue-command v-show="sel==='sw2'" key="sw2" id="sw2_terminal" :commands="sw2Commands" :prompt="sw2Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="Sw2" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP = 'Type commands as shown in the task checklist.';

const mkCommands = (swk, vm) => ({
  help:       () => createStdout(HELP),
  enable:     () => vm.iosEnable(swk),
  configure:  (x) => vm.iosConfigure(swk, x),
  conf:       (x) => vm.iosConfigure(swk, x),
  vlan:       (x) => vm.iosVlan(swk, x),
  name:       (x) => vm.iosName(swk, x),
  interface:  (x) => vm.iosInterface(swk, x),
  int:        (x) => vm.iosInterface(swk, x),
  switchport: (x) => vm.iosSwitchport(swk, x),
  lldp:       (x) => vm.iosLldp(swk, x),
  exit:       () => vm.iosExit(swk),
  end:        () => vm.iosEnd(swk),
  copy:       (x) => vm.iosCopy(swk, x),
});

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/VLAN_Configuration_Sim.png',
      sel: 'sw1',
      totalScore: 0,

      sw1: { mode: 'exec', currentVlan: null, currentIf: null },
      sw2: { mode: 'exec', currentVlan: null, currentIf: null },

      // sw1: task1(8) + task2(9) + task3(4) + saved(1) = 22
      sw1Completion: {
        vlan77: false, vlan77Name: false,
        vlan88: false, vlan88Name: false,
        vlan177: false, vlan177Name: false,
        vlan188: false, vlan188Name: false,
        rangeEntered: false, rangeAccess: false, rangeVlan77: false,
        e03If: false, e03Access: false, e03Vlan88: false, e03Voice188: false,
        e01If: false, e01Voice177: false,
        lldpRun: false, e00If: false, e00LldpTx: false, e00LldpRx: false,
        saved: false,
      },
      // sw2: task1(8) + task2(9) + task3(4) + saved(1) = 22
      sw2Completion: {
        vlan77: false, vlan77Name: false,
        vlan88: false, vlan88Name: false,
        vlan177: false, vlan177Name: false,
        vlan188: false, vlan188Name: false,
        e03If: false, e03Access: false, e03Vlan77: false,
        e01If: false, e01Access: false, e01Vlan88: false, e01Voice188: false,
        e02If: false, e02Voice177: false,
        lldpRun: false, e00If: false, e00LldpTx: false, e00LldpRx: false,
        saved: false,
      },

      sw1Commands: null,
      sw2Commands: null,

      task1Items: [
        { key: 'vlan77',      label: 'vlan 77' },
        { key: 'vlan77Name',  label: 'name IT_User_VLAN' },
        { key: 'vlan88',      label: 'vlan 88' },
        { key: 'vlan88Name',  label: 'name HR_User_VLAN' },
        { key: 'vlan177',     label: 'vlan 177' },
        { key: 'vlan177Name', label: 'name IT_Voice_VLAN' },
        { key: 'vlan188',     label: 'vlan 188' },
        { key: 'vlan188Name', label: 'name HR_Voice_VLAN' },
      ],
      task2Sw1Items: [
        { key: 'rangeEntered', label: 'interface range e0/1 - 2' },
        { key: 'rangeAccess',  label: 'switchport mode access' },
        { key: 'rangeVlan77',  label: 'switchport access vlan 77' },
        { key: 'e03If',        label: 'interface e0/3' },
        { key: 'e03Access',    label: 'switchport mode access' },
        { key: 'e03Vlan88',    label: 'switchport access vlan 88' },
        { key: 'e03Voice188',  label: 'switchport voice vlan 188' },
        { key: 'e01If',        label: 'interface e0/1' },
        { key: 'e01Voice177',  label: 'switchport voice vlan 177' },
      ],
      task2Sw2Items: [
        { key: 'e03If',       label: 'interface e0/3' },
        { key: 'e03Access',   label: 'switchport mode access' },
        { key: 'e03Vlan77',   label: 'switchport access vlan 77' },
        { key: 'e01If',       label: 'interface e0/1' },
        { key: 'e01Access',   label: 'switchport mode access' },
        { key: 'e01Vlan88',   label: 'switchport access vlan 88' },
        { key: 'e01Voice188', label: 'switchport voice vlan 188' },
        { key: 'e02If',       label: 'interface e0/2' },
        { key: 'e02Voice177', label: 'switchport voice vlan 177' },
      ],
      task3Items: [
        { key: 'lldpRun',   label: 'lldp run' },
        { key: 'e00If',     label: 'interface e0/0' },
        { key: 'e00LldpTx', label: 'lldp transmit' },
        { key: 'e00LldpRx', label: 'lldp receive' },
      ],
    };
  },

  computed: {
    sw1Prompt() {
      const m = this.sw1.mode;
      if (m === 'config-if-range') return 'Sw1(config-if-range)#';
      if (m === 'config-vlan')     return 'Sw1(config-vlan)#';
      if (m === 'config-if')       return 'Sw1(config-if)#';
      if (m === 'config')          return 'Sw1(config)#';
      return 'Sw1#';
    },
    sw2Prompt() {
      const m = this.sw2.mode;
      if (m === 'config-if-range') return 'Sw2(config-if-range)#';
      if (m === 'config-vlan')     return 'Sw2(config-vlan)#';
      if (m === 'config-if')       return 'Sw2(config-if)#';
      if (m === 'config')          return 'Sw2(config)#';
      return 'Sw2#';
    },

    task1Progress() {
      const keys = ['vlan77','vlan77Name','vlan88','vlan88Name','vlan177','vlan177Name','vlan188','vlan188Name'];
      const c1 = this.sw1Completion, c2 = this.sw2Completion;
      return keys.flatMap(k => [c1[k], c2[k]]).filter(Boolean).length;
    },
    task1Done() { return this.task1Progress === 16; },

    task2Progress() {
      const c1 = this.sw1Completion, c2 = this.sw2Completion;
      return [
        c1.rangeEntered, c1.rangeAccess, c1.rangeVlan77,
        c1.e03If, c1.e03Access, c1.e03Vlan88, c1.e03Voice188,
        c1.e01If, c1.e01Voice177,
        c2.e03If, c2.e03Access, c2.e03Vlan77,
        c2.e01If, c2.e01Access, c2.e01Vlan88, c2.e01Voice188,
        c2.e02If, c2.e02Voice177,
      ].filter(Boolean).length;
    },
    task2Done() { return this.task2Progress === 18; },

    task3Progress() {
      const keys = ['lldpRun','e00If','e00LldpTx','e00LldpRx'];
      const c1 = this.sw1Completion, c2 = this.sw2Completion;
      return keys.flatMap(k => [c1[k], c2[k]]).filter(Boolean).length;
    },
    task3Done() { return this.task3Progress === 8; },

    saveDone() { return this.sw1Completion.saved && this.sw2Completion.saved; },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
    this.sw1Commands = mkCommands('sw1', this);
    this.sw2Commands = mkCommands('sw2', this);
  },

  methods: {
    getComp(k) { return this[k + 'Completion']; },
    swkLabel(k) { return k === 'sw1' ? 'Sw1' : 'Sw2'; },

    dot(val) {
      return { width:'8px', height:'8px', background: val?'#28C76F':'transparent', border:'2px solid '+(val?'#28C76F':'#6b7280') };
    },

    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },

    normalizeIf(ifStr) {
      return (ifStr || '').toLowerCase()
        .replace(/^fastethernet/, '').replace(/^ethernet/, '')
        .replace(/^fa(?=\d)/, '').replace(/^e(?=\d)/, '')
        .trim();
    },

    updateScore() {
      let score = 0;
      [this.sw1Completion, this.sw2Completion].forEach(c => Object.values(c).forEach(v => { if (v) score++; }));
      this.totalScore = score;
      this.$forceUpdate();
      this.$emit('simulation_update_score', score);
      // sw1(22) + sw2(22) = 44
      if (score >= 44) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },

    iosEnable(swk) { this[swk].mode = 'exec'; return createStdout(''); },

    iosConfigure(swk, x) {
      const s = this[swk];
      if (s.mode !== 'exec') return createStderr('% Already in configuration mode — type "end" to return to exec first');
      if (x._[1] === 'terminal' || x._[1] === 't') {
        s.mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit(swk) {
      const s = this[swk];
      if (s.mode === 'config-if' || s.mode === 'config-if-range' || s.mode === 'config-vlan') {
        s.mode = 'config'; s.currentVlan = null; s.currentIf = null;
      } else if (s.mode === 'config') { s.mode = 'exec'; }
      return createStdout('');
    },

    iosEnd(swk) { this[swk].mode = 'exec'; this[swk].currentVlan = null; this[swk].currentIf = null; return createStdout(''); },

    iosVlan(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config' && s.mode !== 'config-vlan') return createStderr('% Invalid input detected — must be in global or VLAN configuration mode');
      const vlanId = String(x._[1] || '');
      if (!vlanId || isNaN(vlanId)) return createStderr('% Invalid input detected');
      s.mode = 'config-vlan'; s.currentVlan = vlanId; s.currentIf = null;
      const c = this[swk + 'Completion'];
      if (vlanId === '77'  && !c.vlan77)  { c.vlan77  = true; this.updateScore(); }
      if (vlanId === '88'  && !c.vlan88)  { c.vlan88  = true; this.updateScore(); }
      if (vlanId === '177' && !c.vlan177) { c.vlan177 = true; this.updateScore(); }
      if (vlanId === '188' && !c.vlan188) { c.vlan188 = true; this.updateScore(); }
      return createStdout('');
    },

    iosName(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config-vlan') return createStderr('% Invalid input detected — must be in VLAN configuration mode');
      const nameUp = (x._[1] || '').toUpperCase();
      const c      = this[swk + 'Completion'];
      const swName = this.swkLabel(swk);

      const nameMap = {
        '77':  { flag: 'vlan77Name',  match: 'IT_USER_VLAN',   next: '"vlan 88"' },
        '88':  { flag: 'vlan88Name',  match: 'HR_USER_VLAN',   next: '"vlan 177"' },
        '177': { flag: 'vlan177Name', match: 'IT_VOICE_VLAN',  next: '"vlan 188"' },
        '188': { flag: 'vlan188Name', match: 'HR_Voice_VLAN'.toUpperCase(), next: 'Task 2' },
      };
      const entry = nameMap[s.currentVlan];
      if (entry && nameUp === entry.match && !c[entry.flag]) {
        c[entry.flag] = true; this.updateScore();
        const vlanNames = { '77':'IT_User_VLAN', '88':'HR_User_VLAN', '177':'IT_Voice_VLAN', '188':'HR_Voice_VLAN' };
        const isVoice   = s.currentVlan === '177' || s.currentVlan === '188';
        return createStdout(this.guide(
          `VLAN ${s.currentVlan} named ${vlanNames[s.currentVlan]} on ${swName}. ` +
          (isVoice ? 'Voice VLANs carry IP phone traffic — separating data and voice enables QoS prioritization. ' : 'Data VLAN for user workstations. ') +
          (entry.next === 'Task 2' ? '→ All VLANs configured. Configure Task 2: assign VLANs to access ports.' : `→ ${entry.next}.`)
        ));
      }
      return createStdout('');
    },

    iosInterface(swk, x) {
      const s = this[swk];
      const validModes = ['config', 'config-if', 'config-if-range'];
      if (!validModes.includes(s.mode)) return createStderr('% Invalid input detected — must be in configuration mode');

      const sub1 = (x._[1] || '').toLowerCase();
      const c    = this[swk + 'Completion'];

      if (sub1 === 'range') {
        s.mode = 'config-if-range'; s.currentIf = 'range'; s.currentVlan = null;
        if (swk === 'sw1' && !c.rangeEntered) { c.rangeEntered = true; this.updateScore(); }
        return createStdout(this.guide(
          'Interface range entered — commands apply to e0/1 and e0/2 simultaneously. ' +
          '→ "switchport mode access" then "switchport access vlan 77".'
        ));
      }

      let ifArg = String(x._[1] || '');
      let ifNorm = this.normalizeIf(ifArg);
      if (ifNorm === '0/10') ifNorm = '0/0';  // fa0/10 → e0/0
      s.mode = 'config-if'; s.currentIf = ifNorm; s.currentVlan = null;

      if (ifNorm === '0/0' && !c.e00If) { c.e00If = true; this.updateScore(); }
      if (swk === 'sw1') {
        if (ifNorm === '0/3' && !c.e03If) { c.e03If = true; this.updateScore(); }
        if (ifNorm === '0/1' && !c.e01If) { c.e01If = true; this.updateScore(); }
      }
      if (swk === 'sw2') {
        if (ifNorm === '0/3' && !c.e03If) { c.e03If = true; this.updateScore(); }
        if (ifNorm === '0/1' && !c.e01If) { c.e01If = true; this.updateScore(); }
        if (ifNorm === '0/2' && !c.e02If) { c.e02If = true; this.updateScore(); }
      }
      return createStdout('');
    },

    iosSwitchport(swk, x) {
      const s = this[swk];
      const inIf = s.mode === 'config-if' || s.mode === 'config-if-range';
      if (!inIf) return createStderr('% Invalid input detected — must be in interface configuration mode');
      const c    = this[swk + 'Completion'];
      const sub1 = (x._[1] || '').toLowerCase();
      const sub2 = (x._[2] || '').toLowerCase();
      const sub3 = (x._[3] || '').toLowerCase();
      const ifn  = s.currentIf;
      const inRange = s.mode === 'config-if-range';

      // switchport mode access
      if (sub1 === 'mode' && sub2 === 'access') {
        if (swk === 'sw1' && inRange && !c.rangeAccess) {
          c.rangeAccess = true; this.updateScore();
          return createStdout(this.guide('e0/1 and e0/2 set to access mode. → "switchport access vlan 77".'));
        }
        if (swk === 'sw1' && ifn === '0/3' && !c.e03Access) {
          c.e03Access = true; this.updateScore();
          return createStdout(this.guide('Sw1 e0/3 set to access mode. → "switchport access vlan 88".'));
        }
        if (swk === 'sw2' && ifn === '0/3' && !c.e03Access) {
          c.e03Access = true; this.updateScore();
          return createStdout(this.guide('Sw2 e0/3 set to access mode. → "switchport access vlan 77".'));
        }
        if (swk === 'sw2' && ifn === '0/1' && !c.e01Access) {
          c.e01Access = true; this.updateScore();
          return createStdout(this.guide('Sw2 e0/1 set to access mode. → "switchport access vlan 88".'));
        }
        return createStdout('');
      }

      // switchport access vlan <id>
      if (sub1 === 'access' && sub2 === 'vlan') {
        const vid = String(x._[3] || '');
        if (swk === 'sw1' && inRange && vid === '77' && !c.rangeVlan77) {
          c.rangeVlan77 = true; this.updateScore();
          return createStdout(this.guide('e0/1 and e0/2 assigned to VLAN 77 (IT_User_VLAN). IT user workstations on both ports share this data VLAN. → "interface e0/3" to configure the HR port.'));
        }
        if (swk === 'sw1' && ifn === '0/3' && vid === '88' && !c.e03Vlan88) {
          c.e03Vlan88 = true; this.updateScore();
          return createStdout(this.guide('Sw1 e0/3 assigned to VLAN 88 (HR_User_VLAN). → "switchport voice vlan 188" to add the HR voice VLAN.'));
        }
        if (swk === 'sw2' && ifn === '0/3' && vid === '77' && !c.e03Vlan77) {
          c.e03Vlan77 = true; this.updateScore();
          return createStdout(this.guide('Sw2 e0/3 assigned to VLAN 77 (IT_User_VLAN). → "interface e0/1" to configure the HR port.'));
        }
        if (swk === 'sw2' && ifn === '0/1' && vid === '88' && !c.e01Vlan88) {
          c.e01Vlan88 = true; this.updateScore();
          return createStdout(this.guide('Sw2 e0/1 assigned to VLAN 88 (HR_User_VLAN). → "switchport voice vlan 188".'));
        }
        return createStdout('');
      }

      // switchport voice vlan <id>
      if (sub1 === 'voice' && sub2 === 'vlan') {
        const vid = String(x._[3] || '');
        if (swk === 'sw1' && ifn === '0/3' && vid === '188' && !c.e03Voice188) {
          c.e03Voice188 = true; this.updateScore();
          return createStdout(this.guide('Sw1 e0/3 voice VLAN set to 188 (HR_Voice_VLAN). The IP phone on this port tags voice traffic as VLAN 188; PC traffic passes untagged as VLAN 88. → "interface e0/1" to add IT voice VLAN.'));
        }
        if (swk === 'sw1' && ifn === '0/1' && vid === '177' && !c.e01Voice177) {
          c.e01Voice177 = true; this.updateScore();
          return createStdout(this.guide('Sw1 e0/1 voice VLAN set to 177 (IT_Voice_VLAN). e0/1 now carries data (VLAN 77) and voice (VLAN 177) simultaneously. → Configure Task 3: "lldp run" on both switches.'));
        }
        if (swk === 'sw2' && ifn === '0/1' && vid === '188' && !c.e01Voice188) {
          c.e01Voice188 = true; this.updateScore();
          return createStdout(this.guide('Sw2 e0/1 voice VLAN set to 188 (HR_Voice_VLAN). → "interface e0/2" to add IT voice VLAN.'));
        }
        if (swk === 'sw2' && ifn === '0/2' && vid === '177' && !c.e02Voice177) {
          c.e02Voice177 = true; this.updateScore();
          return createStdout(this.guide('Sw2 e0/2 voice VLAN set to 177 (IT_Voice_VLAN). → Configure Task 3: "lldp run".'));
        }
        return createStdout('');
      }

      return createStderr('% Invalid input detected');
    },

    iosLldp(swk, x) {
      const s    = this[swk];
      const sub1 = (x._[1] || '').toLowerCase();
      const c    = this[swk + 'Completion'];

      if (sub1 === 'run') {
        if (s.mode !== 'config') return createStderr('% Invalid input detected — must be in global configuration mode');
        if (!c.lldpRun) { c.lldpRun = true; this.updateScore(); }
        return createStdout(this.guide(
          `LLDP enabled globally on ${this.swkLabel(swk)}. LLDP (IEEE 802.1AB) is the vendor-neutral L2 neighbor discovery protocol — unlike CDP it interoperates with non-Cisco devices. ` +
          '→ "interface e0/0" to enable LLDP on the inter-switch link.'
        ));
      }

      if (s.mode !== 'config-if' && s.mode !== 'config-if-range') return createStderr('% Invalid input detected — must be in interface configuration mode');

      if (sub1 === 'transmit' && s.currentIf === '0/0' && !c.e00LldpTx) {
        c.e00LldpTx = true; this.updateScore();
        return createStdout(this.guide('LLDP TX enabled on e0/0. This switch will send LLDP advertisements (including native VLAN info) to its neighbor. → "lldp receive".'));
      }
      if (sub1 === 'receive' && s.currentIf === '0/0' && !c.e00LldpRx) {
        c.e00LldpRx = true; this.updateScore();
        const swName = this.swkLabel(swk);
        const otherDone = swk === 'sw1' ? this.sw2Completion.e00LldpRx : this.sw1Completion.e00LldpRx;
        return createStdout(this.guide(
          `LLDP RX enabled on ${swName} e0/0. Both directions configured — ${swName} now discovers and advertises to neighbors via LLDP on the inter-switch link. ` +
          (otherDone ? '→ Save both switches: "end" then "copy running-config startup-config".' : `→ Configure the same on ${swk === 'sw1' ? 'Sw2' : 'Sw1'}.`)
        ));
      }
      return createStdout('');
    },

    iosCopy(swk, x) {
      const s = this[swk];
      if (s.mode !== 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" first');
      const c = this[swk + 'Completion'];
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!c.saved) { c.saved = true; this.updateScore(); }
        return createStdout(
          'Destination filename [startup-config]?<br>Building configuration...<br>[OK]' +
          this.guide(`${this.swkLabel(swk)} configuration saved. ` + (this.saveDone ? '✓ Both switches saved — simulation complete!' : '→ Save the remaining switch.'))
        );
      }
      return createStderr('% Invalid input detected');
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#sw1_terminal, #sw2_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

